export default function debounce(fn, delay = 250) {
	let timeout;
	return function debounced(...args) {
		clearTimeout(timeout);
		timeout = setTimeout(() => {
			fn.apply(this, args);
		}, delay);
	};
}
